<template>
  <div class="chat-left">
    <img class="avatar"
         :src="avatar"
         alt="头像"
    >
    <div class="info">
      <div class="name">
        <span class="true-name">{{ name }}</span>
        <span class="nick-name">{{ nickName }}</span>
      </div>
      <div class="dialogue">
        <template v-if="emoji.length > 0">
          <img class="emoji"
               v-for="(item, index) in emoji"
               :key="index"
               :src="item"
               alt="emoji"
          >
        </template>
        <span class="content"
              v-if="content !== ''"
        >
          {{ content }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LiuXuanTestChatLeft',
    props: {
      avatar: {
        type: String,
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
      nickName: {
        type: String,
        required: true,
      },
      content: {
        type: String,
        default: '',
      },
      emoji: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    created() {
      setTimeout(() => {
        this.$emit('addShowItemCount');
        document.getElementById('page-end').scrollIntoView();
      }, 1500);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @avatar-width: 74px;

  .chat-left {
    margin-bottom: @size-medium;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    padding-left: @size-base;
  }

  .avatar {
    margin-right: 26px;
    width: @avatar-width;
    height: @avatar-width;
    display: block;
  }

  .name {
    display: flex;
    align-items: center;
    margin-bottom: @size-extra-small + @size-extra-small / 2;
    font-size: @font-size-small;
    .name {
      color: @color-text-light;
      line-height: 1;
    }
    .nick-name {
      color: @color-text-lighter;
      line-height: 1;
    }
  }

  .dialogue {
    max-width: 560px;
    padding: 22px 26px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    font-size: 26px;
    box-shadow: 0 2px 15px 0 rgba(71, 159, 157, 0.17);
    border-radius: 5px 32px 32px 20px;
  }

  .content {
    color: #333;
    line-height: 1.5;
  }

  .emoji {
    display: block;
    width: @size-medium;
    height: @size-medium;
    &:not(:last-child) {
      margin-right: 14px;
    }
  }
</style>
